export const categories = [
    // Principales
    { id: 1, name: "Informatique", parentId: null, langKey: "category.it" },
    { id: 2, name: "Marketing", parentId: null, langKey: "category.marketing" },
    { id: 3, name: "Bâtiment", parentId: null, langKey: "category.construction" },
    { id: 4, name: "Juridique", parentId: null, langKey: "category.legal" },
    { id: 5, name: "Comptabilité & Finance", parentId: null, langKey: "category.finance" },
    { id: 6, name: "Formation", parentId: null, langKey: "category.training" },
    { id: 7, name: "RH & Recrutement", parentId: null, langKey: "category.hr" },
    { id: 8, name: "Transport & Logistique", parentId: null, langKey: "category.transport" },
    { id: 9, name: "Événementiel", parentId: null, langKey: "category.event" },
    { id: 10, name: "Santé & Bien-être", parentId: null, langKey: "category.health" },
    { id: 11, name: "Design & Création", parentId: null, langKey: "category.design" },
    { id: 12, name: "Services aux entreprises", parentId: null, langKey: "category.business_services" },
  
    // Informatique
    { id: 101, name: "Développement Web", parentId: 1, langKey: "subcategory.web_dev" },
    { id: 102, name: "Développement Mobile", parentId: 1, langKey: "subcategory.mobile_dev" },
    { id: 103, name: "Cybersécurité", parentId: 1, langKey: "subcategory.cybersecurity" },
    { id: 104, name: "Réseaux & Infrastructure", parentId: 1, langKey: "subcategory.network" },
    { id: 105, name: "Maintenance Informatique", parentId: 1, langKey: "subcategory.it_support" },
    { id: 106, name: "Data & Intelligence Artificielle", parentId: 1, langKey: "subcategory.data_ai" },
    { id: 107, name: "Consulting IT", parentId: 1, langKey: "subcategory.it_consulting" },
  
    // Marketing
    { id: 201, name: "SEO / Référencement", parentId: 2, langKey: "subcategory.seo" },
    { id: 202, name: "Publicité en ligne (SEA)", parentId: 2, langKey: "subcategory.sea" },
    { id: 203, name: "Marketing de contenu", parentId: 2, langKey: "subcategory.content_marketing" },
    { id: 204, name: "Emailing", parentId: 2, langKey: "subcategory.emailing" },
    { id: 205, name: "Réseaux sociaux", parentId: 2, langKey: "subcategory.social_media" },
    { id: 206, name: "Branding & Image de marque", parentId: 2, langKey: "subcategory.branding" },
  
    // Bâtiment
    { id: 301, name: "Maçonnerie", parentId: 3, langKey: "subcategory.masonry" },
    { id: 302, name: "Électricité", parentId: 3, langKey: "subcategory.electricity" },
    { id: 303, name: "Plomberie", parentId: 3, langKey: "subcategory.plumbing" },
    { id: 304, name: "Peinture & Revêtement", parentId: 3, langKey: "subcategory.painting" },
    { id: 305, name: "Menuiserie", parentId: 3, langKey: "subcategory.carpentry" },
    { id: 306, name: "Toiture & Couverture", parentId: 3, langKey: "subcategory.roofing" },
    { id: 307, name: "Rénovation", parentId: 3, langKey: "subcategory.renovation" },
  
    // Juridique
    { id: 401, name: "Avocat", parentId: 4, langKey: "subcategory.lawyer" },
    { id: 402, name: "Notaire", parentId: 4, langKey: "subcategory.notary" },
    { id: 403, name: "Conseil juridique", parentId: 4, langKey: "subcategory.legal_advice" },
    { id: 404, name: "Droit du travail", parentId: 4, langKey: "subcategory.labor_law" },
  
    // Finance
    { id: 501, name: "Comptabilité", parentId: 5, langKey: "subcategory.accounting" },
    { id: 502, name: "Audit", parentId: 5, langKey: "subcategory.audit" },
    { id: 503, name: "Gestion de patrimoine", parentId: 5, langKey: "subcategory.wealth_management" },
    { id: 504, name: "Conseil fiscal", parentId: 5, langKey: "subcategory.tax_advice" },
  
    // Formation
    { id: 601, name: "Langues", parentId: 6, langKey: "subcategory.languages" },
    { id: 602, name: "Informatique", parentId: 6, langKey: "subcategory.it_training" },
    { id: 603, name: "Management", parentId: 6, langKey: "subcategory.management" },
    { id: 604, name: "Développement personnel", parentId: 6, langKey: "subcategory.personal_development" },
  
    // RH
    { id: 701, name: "Recrutement", parentId: 7, langKey: "subcategory.recruitment" },
    { id: 702, name: "Coaching", parentId: 7, langKey: "subcategory.coaching" },
    { id: 703, name: "Externalisation RH", parentId: 7, langKey: "subcategory.hr_outsourcing" },
  
    // Transport
    { id: 801, name: "Transport de marchandises", parentId: 8, langKey: "subcategory.freight" },
    { id: 802, name: "Coursiers & livraison urbaine", parentId: 8, langKey: "subcategory.delivery" },
    { id: 803, name: "Logistique & stockage", parentId: 8, langKey: "subcategory.logistics" },
  
    // Événementiel
    { id: 901, name: "Organisation d’événements", parentId: 9, langKey: "subcategory.event_planning" },
    { id: 902, name: "Photographe / Vidéaste", parentId: 9, langKey: "subcategory.photo_video" },
    { id: 903, name: "Location de matériel", parentId: 9, langKey: "subcategory.equipment_rental" },
  
    // Santé & Bien-être
    { id: 1001, name: "Coach sportif", parentId: 10, langKey: "subcategory.fitness_coach" },
    { id: 1002, name: "Nutritionniste / Diététicien", parentId: 10, langKey: "subcategory.nutritionist" },
    { id: 1003, name: "Praticien bien-être", parentId: 10, langKey: "subcategory.wellness_practitioner" },
  
    // Design & Création
    { id: 1101, name: "Graphisme", parentId: 11, langKey: "subcategory.graphic_design" },
    { id: 1102, name: "Motion Design", parentId: 11, langKey: "subcategory.motion_design" },
    { id: 1103, name: "UI/UX Design", parentId: 11, langKey: "subcategory.uiux" },
    { id: 1104, name: "Illustration", parentId: 11, langKey: "subcategory.illustration" },
  
    // Services aux entreprises
    { id: 1201, name: "Nettoyage professionnel", parentId: 12, langKey: "subcategory.cleaning" },
    { id: 1202, name: "Sécurité & Gardiennage", parentId: 12, langKey: "subcategory.security" },
    { id: 1203, name: "Accueil & standard", parentId: 12, langKey: "subcategory.reception" },
  ];
  
  export const entreprises = [
    {
      id: 1,
      name: "WebNova",
      categoryId: 101, // Développement Web
      country: "France",
      city: "Paris",
      address: "10 Rue des Webmasters",
      website: "https://webnova.fr",
      phone: "+33 1 23 45 67 89",
      email: "contact@webnova.fr",
      description: "Agence de développement web sur mesure spécialisée en React et Node.js.",
      rating: 4.8,
    },
    {
      id: 2,
      name: "SafeSec",
      categoryId: 103, // Cybersécurité
      country: "Belgique",
      city: "Bruxelles",
      address: "5 Avenue de la Défense",
      website: "https://safesec.be",
      phone: "+32 2 123 45 67",
      email: "support@safesec.be",
      description: "Experts en audit de sécurité et protection des données.",
      rating: 4.6,
    },
    {
      id: 3,
      name: "RenoBat Pro",
      categoryId: 307, // Rénovation
      country: "France",
      city: "Lyon",
      address: "72 Rue du Bâtiment",
      website: "https://renobatpro.fr",
      phone: "+33 4 56 78 90 12",
      email: "devis@renobatpro.fr",
      description: "Travaux de rénovation intérieure et extérieure, particuliers et professionnels.",
      rating: 4.4,
    },
    {
      id: 4,
      name: "Legalis",
      categoryId: 401, // Avocat
      country: "France",
      city: "Marseille",
      address: "Place du Palais de Justice",
      website: "https://legalis-avocats.fr",
      phone: "+33 4 91 23 45 67",
      email: "info@legalis.fr",
      description: "Cabinet d’avocats spécialisé en droit des affaires et droit du travail.",
      rating: 4.9,
    },
    {
      id: 5,
      name: "ComptaFix",
      categoryId: 501, // Comptabilité
      country: "Luxembourg",
      city: "Luxembourg",
      address: "Boulevard Royal",
      website: "https://comptafix.lu",
      phone: "+352 20 33 45 67",
      email: "hello@comptafix.lu",
      description: "Services comptables et gestion fiscale pour PME et indépendants.",
      rating: 4.7,
    },
    {
      id: 6,
      name: "BoostSocial",
      categoryId: 205, // Réseaux sociaux
      country: "France",
      city: "Toulouse",
      address: "Rue du Marketing Digital",
      website: "https://boostsocial.fr",
      phone: "+33 5 61 12 34 56",
      email: "contact@boostsocial.fr",
      description: "Agence spécialisée dans la gestion et la croissance des réseaux sociaux.",
      rating: 4.5,
    },
    {
      id: 7,
      name: "FormaLang",
      categoryId: 601, // Formation - Langues
      country: "Suisse",
      city: "Genève",
      address: "Rue de l’Éducation",
      website: "https://formalang.ch",
      phone: "+41 22 123 45 67",
      email: "info@formalang.ch",
      description: "Cours de langues pour entreprises et particuliers – en présentiel et à distance.",
      rating: 4.3,
    },
    {
      id: 8,
      name: "ProClean",
      categoryId: 1201, // Nettoyage professionnel
      country: "France",
      city: "Nice",
      address: "ZAC Industrielle de l'Est",
      website: "https://proclean.fr",
      phone: "+33 4 92 00 11 22",
      email: "service@proclean.fr",
      description: "Entretien de bureaux, commerces, copropriétés et usines.",
      rating: 4.2,
    },
    {
      id: 9,
      name: "TransLogix",
      categoryId: 803, // Logistique & stockage
      country: "Pays-Bas",
      city: "Rotterdam",
      address: "Logistic Park 3",
      website: "https://translogix.nl",
      phone: "+31 10 123 45 67",
      email: "contact@translogix.nl",
      description: "Solutions logistiques pour e-commerce et distribution industrielle.",
      rating: 4.6,
    },
    {
      id: 10,
      name: "HealthCoach",
      categoryId: 1001, // Coach sportif
      country: "France",
      city: "Lille",
      address: "Résidence Santé Active",
      website: "https://healthcoach.fr",
      phone: "+33 3 20 30 40 50",
      email: "coach@healthcoach.fr",
      description: "Coaching personnalisé pour remise en forme, musculation et perte de poids.",
      rating: 4.8,
    },
    {
        id: 11,
        name: "BuildExpert",
        categoryId: 308, // Construction générale
        country: "France",
        city: "Bordeaux",
        address: "34 Rue des Entrepreneurs",
        website: "https://buildexpert.fr",
        phone: "+33 5 56 12 45 78",
        email: "contact@buildexpert.fr",
        description: "Entreprise générale de bâtiment pour constructions neuves et extensions.",
        rating: 4.5,
    },
    {
        id: 12,
        name: "GreenElec",
        categoryId: 311, // Électricité
        country: "France",
        city: "Montpellier",
        address: "8 Impasse Volta",
        website: "https://greenelec.fr",
        phone: "+33 4 67 22 33 44",
        email: "info@greenelec.fr",
        description: "Installations électriques, bornes de recharge et domotique.",
        rating: 4.4,
    },
    {
        id: 13,
        name: "VisioCom",
        categoryId: 202, // Communication visuelle
        country: "Belgique",
        city: "Liège",
        address: "Avenue des Graphistes 12",
        website: "https://visiocom.be",
        phone: "+32 4 123 45 67",
        email: "studio@visiocom.be",
        description: "Création de visuels, logos, affiches et identité de marque.",
        rating: 4.7,
    },
    {
        id: 14,
        name: "Juridix",
        categoryId: 401, // Avocat
        country: "France",
        city: "Nantes",
        address: "Place de la République",
        website: "https://juridix.fr",
        phone: "+33 2 40 45 67 89",
        email: "accueil@juridix.fr",
        description: "Conseils juridiques et représentation pour entreprises et particuliers.",
        rating: 4.6,
    },
    {
        id: 15,
        name: "TechAssure",
        categoryId: 402, // Assurance entreprise
        country: "Suisse",
        city: "Lausanne",
        address: "Avenue de la Sécurité 9",
        website: "https://techassure.ch",
        phone: "+41 21 345 67 89",
        email: "devis@techassure.ch",
        description: "Assurances professionnelles sur mesure, RC Pro et multirisques.",
        rating: 4.3,
    },
    {
        id: 16,
        name: "CloudBox",
        categoryId: 104, // Hébergement & cloud
        country: "Luxembourg",
        city: "Luxembourg",
        address: "Tech Park, Bâtiment C",
        website: "https://cloudbox.lu",
        phone: "+352 26 45 78 90",
        email: "support@cloudbox.lu",
        description: "Solutions d’hébergement sécurisé, serveurs dédiés et services cloud.",
        rating: 4.9,
    },
    {
        id: 17,
        name: "EventCraft",
        categoryId: 703, // Organisation d'événements
        country: "France",
        city: "Strasbourg",
        address: "Rue des Congrès",
        website: "https://eventcraft.fr",
        phone: "+33 3 88 77 66 55",
        email: "evenement@eventcraft.fr",
        description: "Organisation de séminaires, soirées, salons et team building.",
        rating: 4.8,
    },
    {
        id: 18,
        name: "LegalTranslate",
        categoryId: 602, // Traduction juridique
        country: "France",
        city: "Lyon",
        address: "Rue du Barreau",
        website: "https://legaltranslate.fr",
        phone: "+33 4 72 23 45 67",
        email: "contact@legaltranslate.fr",
        description: "Services de traduction certifiée pour documents juridiques, notariés et commerciaux.",
        rating: 4.5,
    },
    {
        id: 19,
        name: "Mediavox",
        categoryId: 204, // Vidéo / Motion design
        country: "France",
        city: "Paris",
        address: "Studio 360, Rue du Média",
        website: "https://mediavox.fr",
        phone: "+33 1 53 67 89 00",
        email: "studio@mediavox.fr",
        description: "Création de vidéos promotionnelles, motion design et spots publicitaires.",
        rating: 4.9,
    },
    {
        id: 20,
        name: "FixExpress",
        categoryId: 306, // Réparation (multi-services)
        country: "Belgique",
        city: "Namur",
        address: "Rue de la Maintenance 15",
        website: "https://fixexpress.be",
        phone: "+32 81 23 45 67",
        email: "service@fixexpress.be",
        description: "Service rapide de dépannage à domicile pour plomberie, électricité et serrurerie.",
        rating: 4.2,
    }
      
  ];
  export const popularMainCategories = [1,2,6]
  